import {useSyncExternalStore} from 'react';
import {store} from '@/store';
import type {MinervaSettings} from '@/shared/types/MinervaSettings';

function selectMinerva(
    state: {minervaSettings?: MinervaSettings} | undefined,
): MinervaSettings | null {
    return state?.minervaSettings ?? null;
}

export default function useMinervaSettings() {
    const subscribe = (callback: () => void) => {
        const unsubscribe = store.subscribe(callback);
        return unsubscribe;
    };

    const getSnapshot = () => selectMinerva(store.getState());
    const getServerSnapshot = () => selectMinerva(store.getState());

    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
